import React, { useState, useEffect } from 'react';
import { ModalWrapper, ButtonGroup } from 'components/molecules';
import { PopupProps } from 'react-popup-manager/dist/src';
import { Form, message, Button, Input, Upload, Space } from 'antd';
import { UploadOutlined, CloseOutlined, PaperClipOutlined, DownloadOutlined, SearchOutlined } from '@ant-design/icons';
import { UploadFile } from 'antd/lib/upload/interface';
import { isFileViewer } from 'utils/file-utils';
import { BizCategory } from 'components/TableSearchBox';
import moment, { Moment } from 'moment';
import { DatePicker } from 'components/atoms';
import { useCompanyDetail } from 'hooks';
import { usePopupManager } from 'react-popup-manager';
import { SERVER_URL } from 'commons/constants';
import axios from 'axios';
import { endpoints } from 'services';
import { FileViewerModal } from 'components/molecules';
import { dateFormat } from 'utils/date-utils';

export interface FileInfoType {
    fileid: number, 
    filename: string    
}

export interface CompanyEditModalProps extends PopupProps {
    id: number;
    isPopup?: boolean;
}

const CompanyEditModal = ({ isOpen, onClose, id, isPopup = false }: CompanyEditModalProps): React.ReactElement => {
  /* ======================================================
   * states
   * ====================================================== */    
    const [accountFileList, setAccountFileList] = useState<UploadFile[]>([]);
    const [accountFile, setAccountFile] = useState<FileInfoType>({fileid: 0, filename: ''});  

    const [businessFileList, setBusinessFileList] = useState<UploadFile[]>([]);
    const [businessFile, setBusinessFile] = useState<FileInfoType>({fileid: 0, filename: ''});  

    const [biz, setBiz] = useState<number>();
  /* ======================================================
  * hooks
  * ====================================================== */
  const onUpdateCompleted = (id: string | undefined) => {
    onClose?.(true, id);
  }  


  const { companyInfo, companyInsert, companyUpdate } = useCompanyDetail({id:id, onUpdateCompleted: onUpdateCompleted});  

   /* ======================================================
   * variables
   * ====================================================== */
  const [form] = Form.useForm();
  const { open } = usePopupManager();  
   /* ======================================================
   * events
   * ====================================================== */

    const onCancel = () => {
        onClose?.(false);
    };
        
    const onSubmit = (e) => {

        if (id > 0) {
            companyUpdate({
                id: id,
                name: e.name,
                biz_category_srl: biz,
                reg_date: dateFormat(e.reg_date, 'YYYY-MM-DD'), 
                account_fileData: accountFileList.map((file) => file.originFileObj),
                business_fileData: businessFileList.map((file) => file.originFileObj),
                account_number_file_id: accountFile.fileid,
                business_number_file_id: businessFile.fileid,
              })  
        } else {
            companyInsert({
                id: 0,
                name: e.name,
                biz_category_srl: biz,
                reg_date: dateFormat(e.reg_date, 'YYYY-MM-DD'), 
                account_fileData: accountFileList.map((file) => file.originFileObj),
                business_fileData: businessFileList.map((file) => file.originFileObj),
                account_number_file_id: accountFile.fileid,
                business_number_file_id: businessFile.fileid,
              })  
        }


        //onClose?.(true);
    };

    const onChangeCategory= (value: string) => {
        setBiz(Number(value));
    };     
    
    const checkBiz = (_: any, value) => {
        if (biz && biz > -0) {
          return Promise.resolve();
        }
        return Promise.reject(new Error('biz than zero!'));
    };    
    
    const onDownload = (fileSeq:number, fileName: string): void => {
        axios({
          url: SERVER_URL + endpoints.file.download + '?file_id=' + fileSeq,
          method: 'get',
          responseType: 'blob',
        })
          .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
          })
          .catch(() => {
            message.error('파일 다운로드 중 에러가 발생했습니다.', 1);
          });
        };

    const onFilePreview = (fileId: number, fileName: string, seq: number, gubun: string) => {
        open(FileViewerModal, {
        fileid: fileId,
        filename: fileName,
        seq: seq,
        gubun: gubun,
        editable: true,
        onClose: (isOk, seq, gubun, files) => {
            if (isOk) {};
        },
        });   
        }     
    /* ======================================================
    * methods
    * ====================================================== */
 
       
  /* ======================================================
   * effects
   * ====================================================== */

    useEffect(() => {
        if (!!companyInfo) {
            form.setFieldsValue({
                name: companyInfo?.name,
                reg_date:  (!!companyInfo.reg_date && companyInfo.reg_date !== '0000-00-00') ? moment(companyInfo.reg_date, "YYYY-MM-DD") : undefined, 
                biz_category_srl: companyInfo.biz_category_srl
            });

            setAccountFile({fileid: companyInfo.account_number_file_id, filename: companyInfo.account_number_file_name});
            setBusinessFile({fileid: companyInfo.business_number_file_id, filename: companyInfo.business_number_file_name});
            setBiz(companyInfo.biz_category_srl)
        }
    }, [companyInfo]);

    useEffect(() => {
        form.setFieldValue("reg_date", moment());
    }, []);    

    return (
        <ModalWrapper open={isOpen} onCancel={onCancel} width={550} title={id===0?'고객사 등록':'고객사 수정'} closable>
            <Form
                form={form}
                name="LecturerInfo"
                layout="horizontal"  
                labelCol={{ flex: '120px' }}
                onFinish={onSubmit}
                style={{width:'100%'}}
                autoComplete="off"
            >
                <Form.Item 
                    name="name" 
                    label={'기업명'} 
                    extra={<label style={{color:'red'}}>* 회사명 제한 (한글 ONLY, 영어/특수문자 제한, 공백x, (주), 주식회사x)</label>} 
                    rules={[{ 
                        required: true, 
                        message: '',
                        pattern: new RegExp(/^[ㄱ-ㅎ가-힣0-9]+$/),
                    }]}>
                    <Input type="text" placeholder='기업명을 입력하세요' disabled={isPopup}/>  
                </Form.Item>          
                <Form.Item name="biz_category_srl" label={'업종'} rules={[{ required: true, validator: checkBiz,  message: '' }]}>
                    <BizCategory defaultValue={biz} disable={isPopup} onChangeSelect={onChangeCategory} />                    
                </Form.Item>                     
                <Form.Item name="account_number_file_id" label={'통장사본'}>
                    <Space direction="vertical">
                        <Upload
                            fileList={accountFileList}
                            onChange={({ fileList: list }) => {
                                setAccountFileList(list);
                            }} 
                            beforeUpload={(file, filelist) => {
                                if ((file.size as number) >= 10 * 1024 * 1024) {
                                  message.warn('파일 용량 초과', 1);
                                  return Upload.LIST_IGNORE;
                                }
                            }}                                                       
                            customRequest={() => true}
                            maxCount={1}
                            accept=".pdf,.jpg,.jpeg,.png"
                            showUploadList={false}
                            disabled={accountFile.fileid > 0}
                        >
                            <Button icon={<UploadOutlined />} style={{fontSize:'12px'}}>등록</Button>
                        </Upload>        
                        {(accountFile.fileid > 0) && (
                            <Space key={accountFile.fileid}>
                                <Button onClick={()=>{onDownload && onDownload(accountFile.fileid, accountFile.filename)}} shape="round" icon={<DownloadOutlined />} size='small' style={{padding:'0px 3px'}}/>
                                {isFileViewer(accountFile.filename) && (<Button onClick={()=>{onFilePreview(accountFile.fileid, accountFile.filename, id, 'account')}} shape="round" icon={<SearchOutlined />} size='small' style={{padding:'0px 3px'}}/>)}                                   

                                {accountFile.filename}
                                <CloseOutlined
                                    style={{ fontSize: 12, color: '#b9b9b9' }}
                                    onClick={() => {
                                        setAccountFile({fileid:0, filename:''});
                                    }}
                                />
                            </Space>
                        )} 
                        {accountFileList?.map(({ uid, name }) => (
                            <Space key={uid}>
                            <PaperClipOutlined /><span style={{width: '200px'}}>{name}</span>
                            <CloseOutlined
                                style={{ fontSize: 12, color: '#b9b9b9' }}
                                onClick={() => {
                                    setAccountFileList(accountFileList.map((file) => file).filter((file) => file.uid !== uid));
                                }}
                            />
                            </Space>
                        ))}                                               
                    </Space>                                        
                </Form.Item>                  
                <Form.Item name="business_number_file_id" label={'사업자등록증'}>
                    <Space direction="vertical">
                        <Upload
                            fileList={businessFileList}
                            onChange={({ fileList: list }) => {
                                setBusinessFileList(list);
                            }} 
                            beforeUpload={(file, filelist) => {
                                if ((file.size as number) >= 10 * 1024 * 1024) {
                                  message.warn('파일 용량 초과', 1);
                                  return Upload.LIST_IGNORE;
                                }
                            }}                                                       
                            customRequest={() => true}
                            maxCount={1}
                            accept=".pdf,.jpg,.jpeg,.png"
                            showUploadList={false}
                            disabled={businessFile.fileid > 0}
                        >
                            <Button icon={<UploadOutlined />} style={{fontSize:'12px'}}>등록</Button>
                        </Upload>        
                        {(businessFile.fileid > 0) && (
                            <Space key={businessFile.fileid}>
                                <Button onClick={()=>{onDownload && onDownload(businessFile.fileid, businessFile.filename)}} shape="round" icon={<DownloadOutlined />} size='small' style={{padding:'0px 3px'}}/>
                                {isFileViewer(businessFile.filename) && (<Button onClick={()=>{onFilePreview(businessFile.fileid, businessFile.filename, id, 'identity')}} shape="round" icon={<SearchOutlined />} size='small' style={{padding:'0px 3px'}}/>)}                                   

                                {businessFile.filename}
                                <CloseOutlined
                                    style={{ fontSize: 12, color: '#b9b9b9' }}
                                    onClick={() => {
                                        setBusinessFile({fileid:0, filename:''});
                                    }}
                                />
                            </Space>
                        )} 
                        {businessFileList?.map(({ uid, name }) => (
                            <Space key={uid}>
                            <PaperClipOutlined /><span style={{width: '200px'}}>{name}</span>
                            <CloseOutlined
                                style={{ fontSize: 12, color: '#b9b9b9' }}
                                onClick={() => {
                                    setBusinessFileList(businessFileList.map((file) => file).filter((file) => file.uid !== uid));
                                }}
                            />
                            </Space>
                        ))}                                               
                    </Space>                                       
                </Form.Item>                              
                <Form.Item 
                    name="reg_date" 
                    label={'등록일'} 
                    rules={[{ required: true, message: '' }]}
                >
                    <DatePicker 
                        showTime={false}
                        format="YYYY-MM-DD"
                        disabled={isPopup}
                    />  
                </Form.Item> 
                <ButtonGroup className={'buttonsWrapper'}>
                    <Button onClick={onCancel}>닫기</Button>
                    <Button htmlType="submit"  type="primary">{id===0?'등록':'수정'}</Button>
                </ButtonGroup>                
            </Form>
        </ModalWrapper>  
    )    
};

export default React.memo(CompanyEditModal);    